import axios from "axios";
import merge from "lodash/merge";

const API = axios.create({
  baseURL: "/api",
  withCredentials: true,
});

const api = {
  getMe: () => API.get("/me"),
  updateAttribute: (id, payload, params) =>
    API.patch(`/commissions/${id}`, {
      setting: params,
      data: {
        attributes: [payload],
      },
      fields: "id",
      extra_fields: `attributes.${payload.id}`,
    }),
  getCommissionUserDetails: (params) =>
    API.get(
      `/commissions`,
      merge(
        {
          params: {
            fields: "user.avatar",
            extra_fields: "user.fullName",
            "setting[with_relations]": 1,
            "page[limit]": -1,
          },
        },
        params
      )
    ),
  createServicedProduct: (payload) => API.post("/serviced_products", payload),
  getAutoselect: (endpoint, params) =>
    API.get(`/${endpoint}/autoselect`, params),
  getSettings: (params) => {
    return API.get(`/settings`, { params });
  },
  getCommissionHistory: (id, params) =>
    API.get(`/commissions/${id}/commission_histories`, params),
  getMeta: (endpoint, params = {}) => API.get(`/${endpoint}/meta`, params),
  getProducts: (params) => API.get(`/products/autoselect`, { params }),
};

export default api;
